import { createException, RegistryErrorCode } from '../createException';
import { IResourceLoader, IRegistryFactory } from '../types';

export const EXTERNAL_REGISTRY_OVERRIDE_NAMESPACE = 'registry';

export function getRegistryBundleID(host: string) {
  return `${host}Registry`;
}

export function getRegistryManifestURL(baseURL: string) {
  return `${baseURL}/registry-manifest.min.json`;
}

export async function loadExternalRegistry<
  TComponentModel,
  TParts extends Extract<keyof TComponentModel, string> = never,
>({
  resourceLoader,
  url,
  host,
}: {
  resourceLoader: IResourceLoader;
  url: string;
  host: string;
}): Promise<IRegistryFactory<TComponentModel, TParts>> {
  const response = await resourceLoader.fetch({
    url: getRegistryManifestURL(url),
  });

  const manifest = JSON.parse(response);

  const id = getRegistryBundleID(host);

  if (!manifest[`${id}.js`]) {
    throw createException(RegistryErrorCode.NoRegistryOverrideForHost);
  }

  const loadBundle = resourceLoader.createBundleLoader({ environment: {} });

  const runtimeURL = manifest['webpack-runtime.js'];
  if (runtimeURL) {
    await loadBundle({
      url: runtimeURL,
    });
  }

  const bundleUrl = manifest[`${id}.js`];

  const registry = await loadBundle<{
    default: IRegistryFactory<TComponentModel, TParts>;
  }>({
    url: bundleUrl,
    id,
  });

  return registry.default;
}
